module.exports = __webpack_public_path__ + "static/1-a584295c4fce32e2dddcd254ef14ec07.jpg";